
import  { memo} from 'react';
import VideoCard from '../socialnetwork/VideoCard';

import YouTubeCard from '../socialnetwork/YouTubeCard';

const getCategoryStyles = (category) => {
    switch (category) {
      case 'alumno':
        return {
          titleBg: 'bg-gradient-to-t from-purple-700 to-transparent',
          borderColor: 'border-purple-500',
          textColor: 'text-white',
        };
      case 'docente':
        return {
          titleBg: 'bg-gradient-to-t from-orange-700 to-transparent',
          borderColor: 'border-orange-500',
          textColor: 'text-white'
        };
      case 'plataforma':
        return {
          titleBg: 'bg-black bg-opacity-50 ',
          borderColor: 'border-transparent',
          textColor: 'text-white' // Cambiar a negro para mejor contraste en verde
        };
      default:
        return {
          titleBg: 'bg-gradient-to-t from-gray-700 to-transparent',
          borderColor: 'border-gray-500',
          textColor: 'text-white'
        };
    }
};

const Row1 = memo(({item, category}) => {
    const styles = getCategoryStyles(category);
    var _tematica = "" 
    if(category == "alumno"){
        _tematica = `autor: ${item.creator_alias} | Creación Literaria Estudiantil | `

    }

    _tematica = _tematica +item.tematica

    return (
        <div
          key={item.id}
          onClick={() => window.location.href = `/lecturas/${item.id}`}
          className={`relative mb-4 break-inside-avoid overflow-hidden rounded-lg shadow-lg cursor-pointer transition-transform duration-300 hover:scale-105 hover:shadow-xl border-2 ${styles.borderColor}`}
        >
          {/* Imagen */}
          <img
            src={`https://img-dinoblanco-shs.s3.amazonaws.com/album/${item.id}.jpg`}
            alt={`${item.titulo}`}
            className={`w-full transition-transform duration-300`}
            onError={(e) => {
                e.target.src = 'https://img-dinoblanco-shs.s3.amazonaws.com/brand/sumaqtaiimagenotfound.jpg'; // Reemplaza con la imagen por defecto
              }}
          />
          {/* Metadata */}
          <div className={`absolute top-0 left-0 w-full flex justify-between p-2`}>
            <span className={`bg-white bg-opacity-75 text-xs text-gray-800 px-2 py-1 rounded-full shadow-sm `}>
              {_tematica}
            </span>
          </div>
          {/* Título con mejor contraste y sombra */}
          <div
            className={`absolute bottom-0 left-0 w-full ${styles.textColor} text-sm font-medium p-2 text-center transition-opacity duration-300 hover:bg-opacity-75 ${styles.titleBg} shadow-md`}
          >
            {item.titulo}
          </div>
        </div>)
})


const CardGrid = ({ data, visibleItems, data_lecturas_leidas }) => {

    return (
        <div className="columns-2 sm:columns-2 md:columns-3 lg:columns-4 xl:columns-5  flex-nowrap gap-2 overflow-x-auto p-1 border">
            {
                data.slice(0, visibleItems).
                filter(lectura => 
                    !data_lecturas_leidas.some(leida => leida.lecture_id === lectura.id)
                ).map((item, index) => {
                    if(item.active  != false){

                      if((item.tipomated || '').toLowerCase().includes("video".toLowerCase())){
                        console.log(item);
                        if((item.tipomated || '').toLowerCase().includes("videopinterest".toLowerCase())){
                          return <VideoCard videoSrc={item.linkmatedrepo} itemLecture={item}></VideoCard>
                        }else if((item.tipomated || '').toLowerCase().includes("videoyoutube_classic".toLowerCase())){
                          return  <YouTubeCard url={item.linkmatedrepo} itemLecture={item}/>
                        }else if((item.tipomated || '').toLowerCase().includes("videoyoutube_short".toLowerCase())){
                          return   <YouTubeCard url={item.linkmatedrepo} isShort itemLecture={item}/> 
                        }
                      }else{

                        if(item.creator_alias == null || item.creator_alias.includes("@sumaqt.")){

                          if(parseInt(item.grado,10) >=20)
                              return <Row1 key={item.id} item={item} category={'docente'} />
                          else
                              return <Row1 key={item.id} item={item} category={'plataforma'} />

                        }else{
                            return <Row1 key={item.id} item={item} category={'alumno'} />
                        }

                      }
                    }else{
                        console.log(item)
                        console.log(".a.a.a.a.a.a")
                        return <></>
                    }
                })
            }
        </div>
    )
};

export default CardGrid;